import { supabase } from "../supabase";
import ErrorToast from './errortoast.js'

export async function getCollections() {
    try {
        const { error, data } = await supabase
            .from("packs")
            .select()
            .match({ user_id: supabase.auth.currentUser.id });
        if (error) {
            throw error;
        }
        return data;
    } catch (error) {
        ErrorToast("Getting Collections Failed.", error)
    }
}

export async function getPublicCollections() {
    try {
        const { error, data } = await supabase
            .from("packs")
            .select()
            .match({ public: true });
        if (error) {
            throw error;
        }
        return data;
    } catch (error) {
        ErrorToast("Getting Public Collections Failed.", error)
    }
}

export async function addCollection(collection) {
    try {
        const { error } = await supabase
            .from("packs")
            .insert(
                [
                    {
                        name: collection.name,
                        description: collection.description,
                        user_id: supabase.auth.currentUser.id,
                        id: collection.id,
                        public: collection.public,
                        categories: "",
                        isDisabled: false,
                        emoji: collection.emoji,
                    }
                ]
            );
        if (error) {
            throw error;
        }
        return;
    } catch (error) {
        ErrorToast("Adding Collection Failed.", error)
    }
}

export async function deleteCollection(collection) {
    try {
        const { error, data } = await supabase
            .from("cards")
            .delete()
            .match({ pack_id: collection.id });
        if (error) throw error;
        

        const { e, d } = await supabase
            .from("packs")
            .delete()
            .match({ id: collection.id });
        if (e) throw e;
        
        return true;
    } catch (error) {
        ErrorToast("Deleting Collection Failed.", error)
        return false;
    }
}
